import { AbilityBuilder, Ability } from '@casl/ability';
import { User } from '@/constants/types';
import { USER_ROLES } from '@/constants/app';

export type Actions = 'create' | 'read' | 'update' | 'delete' | 'manage';
export type Subjects = 'User' | 'Student' | 'Staff' | 'Parent' | 'Dashboard' | 'Profile' | 'all';

export type AppAbility = Ability<[Actions, Subjects]>;

export const defineAbilitiesFor = (user: User | null): AppAbility => {
  const { can, cannot, build } = new AbilityBuilder<AppAbility>(Ability);

  if (!user) {
    cannot('manage', 'all');
    return build();
  }
console.log(user)
  switch (user.role) {
    
    case USER_ROLES.Booking_Admin:
    case USER_ROLES.Booking_SuperAdmin:
      can('manage', 'all');
      can('read', 'Dashboard');

      break;

        case USER_ROLES.Booking_Viewer:


      can('read', 'Dashboard');
      can('manage', 'Student');
      can('read', 'Parent');
      can('read', 'User');
      can('update', 'Profile');
      cannot('delete', 'User');
      cannot('create', 'Staff');
      cannot('update', 'Staff');
      cannot('delete', 'Staff');
      break;
    default:
      cannot('manage', 'all');
      break;
  }

  return build();
};

export const checkPermission = (
  user: User | null,
  action: Actions,
  subject: Subjects
): boolean => {
  const ability = defineAbilitiesFor(user);
  return ability.can(action, subject);
};